// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "_" + __webpack_require__.h().slice(0, 4) + "" + "d459" + "." + "5697dd97" + ".chunk.js";
};